import { useMemo } from 'react'
import { useBlobUrl, type BlobUrlResult } from './useBlobUrl.js'

export type SignedAttachmentUrl = BlobUrlResult

/**
 * Fetches `GET /attachments/:id` as a JWT-authed blob and exposes a
 * `URL.createObjectURL` handle. The shared `api` client only speaks JSON,
 * so this uses raw `fetch` (via `useBlobUrl`) to obtain the raw Response
 * (Task 7).
 */
export function useSignedAttachmentUrl(
  attachmentId: string | null,
): SignedAttachmentUrl {
  const url = useMemo(() => (attachmentId === null ? null : `/api/attachments/${attachmentId}`), [attachmentId])
  return useBlobUrl(url)
}
